import _Object$freeze from 'babel-runtime/core-js/object/freeze';
export var Roles = _Object$freeze({
  ADMIN: 'admin',
  USER: 'user'
});


// WEBPACK FOOTER //
// ./src/service/keycloak/Roles.js